import {
  CreateDependsOnFactory,
  FormControlDependsOnSchema,
  FormControlDependsOnThenEnum,
  IFormControlDependsOnSchema
} from "@generation/core";
import { AbstractDependsOnMapper } from "./AbstractDependsOnMapper";
import { IDependsOn, INestedDependsOn } from "../../client/model/dependsOn";

export class SetValueDependsOnMapper extends AbstractDependsOnMapper {
  convertNested(item: INestedDependsOn, _fieldType: string): FormControlDependsOnSchema<any> {
    return this.convertField(this.getBaseNestedProperties(item), item.setValue);
  }
  convert(item: IDependsOn, _fieldType: string): FormControlDependsOnSchema<never[]> {
    return this.convertField(this.getBaseProperties(item), item.setValue);
  }

  private convertField(
    baseProperties: IFormControlDependsOnSchema<any>,
    setValue: string | undefined
  ): FormControlDependsOnSchema<any> {
    return CreateDependsOnFactory.create({
      ...baseProperties,
      then: FormControlDependsOnThenEnum.SetValue,
      setWithValue: () => setValue ?? ""
    });
  }
}
